import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SidenavService } from '../services/sidenav.service';

/** Перед входом на choose-account: закрыть все MatDialog и основной sidebar. */
export const chooseAccountResetUiGuard: CanActivateFn = () => {
  inject(MatDialog).closeAll();

  const sidenavSvc = inject(SidenavService);
  if (sidenavSvc.sidenav?.opened) {
    sidenavSvc.close();
  }

  return true;
};
